import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { Router } from '@angular/router';
import { sweetAlert } from 'src/app/utils/swal';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
@UntilDestroy()

@Component({
  selector: 'app-trips-distribution-modal',
  templateUrl: './trips-distribution-modal.component.html',
  styleUrls: ['./trips-distribution-modal.component.css']
})
export class TripsDistributionModalComponent implements OnInit {
  @Input() trips: any;
  @Input() preServiceAreas: any;
  companies: any = [];
  preAppointmentType: any;
  preSpacetypes: any;
  preMembers: any;
  selectedCompany: any = null;
  companyDetail:any;
  selectedTrips:any;
  preCompanies:any = {}
  @Output() closeModal = new EventEmitter<any>();
  @Output() editTrip = new EventEmitter<any>();
  previousAssignedCompanies: any
  isSubmitted = false;
  status: any;
  action:any;
  search:any;
  levelofservices:any;
  preLevelOfService: any = {};

  constructor(
    private tripService : TripService,
    private companyService: CompanyService,
    private appointmentService: AppointmentTypeService,
    private configurationService: ConfigurationService,
    private spaceTypeService:SpaceTypeService,
    private memberService: MemberService,
    private router: Router,
    private levelOfService: LosService,
    private credentailService:  CredentialService
  ) {}

  ngOnInit(): void {
    this.status = this.trips && this.trips.length ? this.trips[0].status : '';
    this.selectedTrips = this.trips.map((trip: any) => {
      return trip.id
    })
    this.previousAssignedCompanies = this.trips.map((trip: any) => {
      return {company: trip.company, trip: trip.id}
    });
    this.getAllAppointment();
    // this.getAllMembers();
    this.getSpaceType();
    this.getAllCompanies();
    this.getLevelOfService()
  }

  getAllCompanies() {
    this.credentailService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        this.preCompanies = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
        this.companies = data.results.map((company: any) => ({
          ...company,
          isSelected: false
        }));
      }
    });
  }

  getAllAppointment() {
    this.appointmentService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results && data.results.length) {
        this.preAppointmentType = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getSpaceType() {
    this.spaceTypeService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        this.preSpacetypes = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  // getAllMembers() {
  //   this.memberService.getMembers({limit:999}).pipe(untilDestroyed(this)).subscribe((data: any) => {
  //     if (data && data.results && data.results.length) {
  //       this.preMembers = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
  //     }
  //   });
  // }

  getDashboardDetail() {
    this.configurationService.getDashboardDetails(this.selectedCompany.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
       this.companyDetail = {drivers:data.drivers, vehicles:data.vehicles};
      }
    })
  }

  onSelectCompany(company: any) {
    if(!company)return;
    this.companies = this.companies.map((c: any) => ({
      ...c,
      isSelected: c === company ? !c.isSelected : false
    }));
    this.selectedCompany = this.companies.find((c: any) => c.isSelected) || null;
    this.getDashboardDetail();

  }

  onCloseModal() {
    this.closeModal.emit();
  }

  assign() {
    this.isSubmitted = true;

    if (!(this.selectedCompany && this.trips && this.trips.length)) {
      return;
    }

    if (this.isViolationExist()) {
      sweetAlert('Alert', 'A service area violation exists. Do you want to proceed?', 'warning', 'Ok', 'Cancel')
        .then((result) => {
          if (result.isConfirmed) {
            this.distribute();
          }
        });
    } else {
      this.distribute();
    }
  }

  isViolationExist() {
    const companyServiceAreas = this.selectedCompany.serviceAreas;

    if (!(companyServiceAreas && companyServiceAreas.length)) {
      return false;
    }

    const tripsServiceAreas = Array.from(
      new Set(this.trips.map((trip: any) => trip.serviceArea))
    );

    return !tripsServiceAreas.every(serviceArea => companyServiceAreas.includes(serviceArea));
  }

  distribute() {

    const newSelectedTrips = this.trips.reduce((acc: any[], trip: any) => {
      if (trip.company !== this.selectedCompany.id) {
        acc.push(trip.id);
      }
      return acc;
    }, []);

    if (!(newSelectedTrips && newSelectedTrips.length)) {
      sweetAlert('Alert', 'Trips already assigned to same company?', 'warning', 'Ok')
        .then((result) => {
          if (result.isConfirmed) {
           
          }
        });
      return;
    } 

    const pre = this.previousAssignedCompanies.filter((trip: any) => trip.company !== this.selectedCompany.id);
    const payload = {
      pre: pre,
      selectedIds: newSelectedTrips,
      company: this.selectedCompany.id,
      status: "offered"
    };
    this.action = 'assign';
    this.apiRequest(payload);
  }

  unassign() {
    const payload = {
      pre: this.previousAssignedCompanies,
      selectedIds: this.selectedTrips,
      company: null,
      status: "scheduled"
    };
    this.action = 'unassign';
    this.apiRequest(payload);
  }

  apiRequest(payload: any) {
    this.tripService.assignToCompany(payload).pipe(untilDestroyed(this)).subscribe({
      next: (res) => {
        if (res) {
          this.editTrip.emit({tripsIds:this.selectedTrips, company :this.selectedCompany?.id, source:this.action})
        //  this.onCloseModal();
        }
      }
    })
  }

  getLevelOfService() {
    this.levelOfService.getPicker({ isActive: true, limit:9999 })
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          this.levelofservices = data.results;
          this.preLevelOfService = this.levelofservices.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }
}
